export enum AUTH_PHASES {
  EMAIL_SUBMIT = "EMAIL_SUBMIT",
  PASSWORD_LOGIN = "PASSWORD_LOGIN",
  NICKNAME_SUBMIT = "NICKNAME_SUBMIT",
  ACTIVATION = "ACTIVATION",
  SIGN_IN = "SIGN_IN",
}
